import { FormValidator } from '../../ui/gzForm/formField/types/form-validator';
import { GzDialogWebComponent } from '../../ui/gzDialog';
import { translateFn } from '../../utils/translator.helper';
import { GzDialogEvents } from '../../ui/gzDialog/component/GzDialog';
import { GzAiFeedbackWebComponent } from '../gzAiFeedback';
import { ToastSeverity } from '../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../ui/gzToastNotification';

export interface PopUpConfiguration {
  validators?: Array<FormValidator>;
}

export class FeedbackFactory {
  public static displayFeedBackDialog(
    chatCardId = '',
    confirmCallbackFn: Function = () => {},
    updateUserSessionCallbackFn: Function = () => {},
    cancelCallbackFn: Function = () => {},
    configuration: PopUpConfiguration = {}
  ): void {
    const dialogContent = new GzAiFeedbackWebComponent();
    if (configuration.validators) {
      dialogContent.validators.push(...configuration.validators);
    }

    const dialog = GzDialogWebComponent.buildDialogElement({
      headline: translateFn('Submit feedback'),
      bodyContent: dialogContent,
      isOpen: true,
      isWindow: false,
      overlayZIndex: 99999,
    });

    dialogContent.addEventListener(GzDialogEvents.CANCEL, (): void => {
      cancelCallbackFn();
      dialog.close();
    });
    dialogContent.addEventListener(GzDialogEvents.CONFIRM, async (event: CustomEvent): Promise<void> => {
      try {
        await confirmCallbackFn(event, chatCardId);
        dialog.close();
        GzToastNotificationWebComponent.buildToastWrapperElement({
          message: translateFn('Thank you for being part of our journey!'),
          severity: ToastSeverity.SUCCESS,
        });
      } catch (e) {
        dialog.close();
        GzToastNotificationWebComponent.buildToastWrapperElement({
          message: translateFn('Failed to submit feedback. Please try again later.'),
          severity: ToastSeverity.ERROR,
        });
        throw e;
      }
    });

    dialogContent.addEventListener('click', (event): void => {
      updateUserSessionCallbackFn(chatCardId);
    });
    dialogContent.addEventListener('keydown', (event): void => {
      updateUserSessionCallbackFn(chatCardId);
    });

  }
}
